// created 9-apr-2019 by rich braun <docker@instantlinux.net>

import React from 'react';
import { Route } from 'react-router-dom';
import welcome from './views/welcome.js';
import aboutPage from './views/aboutPage.js';
import apikeyNew from 'apicrud-ui/views/apikey-new.js';
import cnfrm from 'apicrud-ui/views/confirm.js';
import confirmWait from 'apicrud-ui/views/confirm-wait.js';
import confirmRSVP from './views/rsvp.js';
import MFA from 'apicrud-ui/views/mfa.js';
import loginExt from 'apicrud-ui/lib/login-ext.js';
import magic from 'apicrud-ui/lib/magic.js';
import prefs from 'apicrud-ui/lib/prefs.js';

const customRoutes = [
    <Route exact path="/" component={welcome} />,
    <Route exact path="/welcome" component={welcome} />,
    <Route exact path="/about" component={aboutPage} />,
    <Route exact path="/apikeynew" component={apikeyNew} />,
    <Route exact path="/confirm" component={cnfrm} />,
    <Route exact path="/confirmwait" component={confirmWait} />,
    <Route exact path="/ev" component={magic} noLayout />,
    <Route exact path="/login/ext" component={loginExt} />,
    <Route exact path="/mfa" component={MFA} />,
    <Route exact path="/prefs" component={prefs} noLayout />,
    <Route exact path="/rsvp" component={confirmRSVP} />,
];

export default customRoutes;
